module.exports = __webpack_public_path__ + "assets/img/Icon-nav.c95771dc.svg";